import { LoaderService } from "../shared/loader/loader.service";
import { AlertService } from "../shared/alert/alert.service";
import { ToastService } from "./toast/toast.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Injector } from "@angular/core";
import { Location } from '@angular/common';
import { DbService } from "../services/db.service";
import { ConfirmService } from "./confirm/confirm.service";
import { isNumber } from "util";


export class BaseComponent {
  public loader: LoaderService;
  protected alert: AlertService;
  protected toast: ToastService;
  protected router: Router;
  protected route: ActivatedRoute;
  protected location: Location;
  protected db: DbService;
  protected confirm: ConfirmService;

  constructor(injector: Injector) {
    this.loader = injector.get(LoaderService);
    this.alert = injector.get(AlertService);
    this.toast = injector.get(ToastService);
    this.router = injector.get(Router);
    this.route = injector.get(ActivatedRoute);
    this.location = injector.get(Location);
    this.db = injector.get(DbService);
    this.confirm = injector.get(ConfirmService);
  }

  //P.S. used in component to lookup a value from a lookup table
  public lookup(id: any, array: any[], idField = "id", nameField = "name") {
    let ret = null; //default return
    array.forEach(item => {
      if (item[idField] == id) {
        ret = item[nameField];
      }
    });
    return ret;
  }
  public hasRole(sRole: any) {
    let ret = false;
    let urs: any = sessionStorage.getItem('userRoles');
    let userRoles = JSON.parse(urs);
    userRoles.forEach((ur: any) => {
      if (ur == sRole) ret = true
    })
    return ret
  }
  //have a universal and generic error handler here
  public error(s: string, s2: string) { this.alert.danger(s + " " + s2) }

  public getQueryParameter(sQuery: string) {
    // returns always a string
    const QueryString = this.route.snapshot.queryParams[sQuery];
    let ret = "";
    if (QueryString !== null) { // P.S. called with non-empty IdeaId
      ret = QueryString;
    }
    return ret;
  }
  getIntQueryParamOrDefault(sQuery: string, iDefault: number) {
    const QueryString = this.route.snapshot.queryParams[sQuery];
    let ret = iDefault;
    if (QueryString != null) { // P.S. called with non-empty IdeaId
      ret = parseInt(QueryString, 10);
    }
    return ret;
  }
  randomString(length: number) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }

  groupBy(array: any, keyname: string) {
    //returns an array of keys and values
    //where values is an array of elements of array with key
    let result = array.reduce((prev: any, cur: any) => {
      let existing = prev.find((x: any) => x.key === cur[keyname]);

      if (existing)
        existing.values.push(cur)
      else
        prev.push({
          key: cur[keyname],
          values: [cur]
        });
      return prev;
    }, []);
    return result;
  }

  sort(array: any, fieldname: string) {
    let ret = array.sort((a: any, b: any) => {
      if (a[fieldname] > b[fieldname]) return 1
      if (a[fieldname] < b[fieldname]) return -1
      return 0
    })
    return ret
  }
  sortDirection(array: any, fieldname: string, ascending: boolean) {
    let direction = ascending ? 1 : -1
    let ret = array.sort((a: any, b: any) => {
      if (a[fieldname] > b[fieldname]) return 1 * direction
      if (a[fieldname] < b[fieldname]) return -1 * direction
      return 0
    })
    return ret
  }
  sortGeneric(array: any[], fieldname: string, sortArray: any[]) {
    let sa = sortArray.find(x => x.name === fieldname)
    if (!sa) {
      sa = { name: fieldname, value: true }
      sortArray.push(sa)
    }
    const direction = sa.value ? 1 : -1
    sa.value = !sa.value

    const sample = array[0]?.[fieldname]

    const isNumber = typeof sample === 'number'
    const isDate = sample instanceof Date || (
      typeof sample === 'string' &&
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(sample) &&
      !isNaN(Date.parse(sample))
    )

    return array.sort((a, b) => {
      const va = a[fieldname]
      const vb = b[fieldname]

      if (isNumber) return (va - vb) * direction

      if (isDate) {
        const da = new Date(va).getTime()
        const db = new Date(vb).getTime()
        return (da - db) * direction
      }

      // Default to string sort
      const sa = va?.toString().toLowerCase() || ''
      const sb = vb?.toString().toLowerCase() || ''
      if (sa > sb) return 1 * direction
      if (sa < sb) return -1 * direction
      return 0
    })
  }



  sortUpDown(array: any, fieldname: string, sortDirection: boolean) {

    let direction = sortDirection ? 1 : -1
    sortDirection = !sortDirection

    array.sort((a: any, b: any) => {
      let valA = typeof a[fieldname] === 'string' ? a[fieldname].toLowerCase() : a[fieldname];
      let valB = typeof b[fieldname] === 'string' ? b[fieldname].toLowerCase() : b[fieldname];

      if (valA > valB) return 1 * direction;
      if (valA < valB) return -1 * direction;
      return 0;
    });
    return sortDirection
  }

  minmax(array: any, fieldname: string) {
    let min = array[0][fieldname]
    let max = min
    array.forEach((a: any) => {
      if (a[fieldname] < min) min = a[fieldname]
      if (a[fieldname] > max) max = a[fieldname]
    });
    return { min, max }
  }

  findObjectProp(array: any, prop: string, id: any) {
    let ret = ""
    let obj = array.find((x: any) => x.id == id)
    return obj == null ? "" : obj[prop]
  }

  generateRandomString(length: number): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }
  getKeys(obj: any) {
    if (obj == null) return []
    let keys: any = []
    let i = 0;
    Object.keys(obj).forEach(key => {
      const k = { id: i, name: key } //so it can be handeld in sa-select
      keys.push(k)
      i++
    });

    return keys
  }
  //convert collection to array of objects
  collectionToArray2(obj: any) {
    let keys = []
    for (let key in obj) {
      keys.push({ id: keys.length, name: key, ...obj[key] })
    }
    return keys
  }
  addIterator(obj: any) {
    // this method takes an object and adds an iterator for all properties
    // that way in angular you can use ngFor
    let keys = []
    for (let key in obj) {
      keys.push({ id: keys.length, name: key })
    }
    return keys
  }
  toAny(obj: unknown): any {
    return obj as any
  }
  // firebase stores objects as collections
  // for handling in angular we need to convert them to arrays
  // special property names "key" and "property" should not appear in the objects of the collections:
  collectionToArrayFB(obj: any) {
    let keys = []
    for (let key in obj) {
      keys.push({ key: keys.length, property: key, ...obj[key] })
    }
    return keys
  }

  // the converted array can be converted back to a collection
  // for submission to firebase
  arrayToCollectionFB(array: any) {
    let obj: any = {}
    array.forEach((element: any) => {
      let newELement: any = {}
      let keys = Object.keys(element)
      keys.forEach((key: any) => {
        if (key != "key" && key != "property") {
          newELement[key] = element[key]
        }
      });
      obj[element.property] = newELement
    });
    return obj
  }

  //remove key and property from object
  removeKeyAndPropertyFB(obj: any) {
    let newELement: any = {}
    let keys = Object.keys(obj)
    keys.forEach((key: any) => {
      if (key != "key" && key != "property") {
        newELement[key] = obj[key]
      }
    });
    return newELement
  }

  // create function to convert timestamp into formatted dateAndTime
  convertTimestamp(timestamp: any) {
    const d = new Date(timestamp);
    const date = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    const hours = d.getHours();
    const minutes = d.getMinutes();
    const seconds = d.getSeconds();
    const formattedDate = `${month}/${date}/${year}`;
    const formattedTime = `${hours}:${minutes}:${seconds}`;
    return `${formattedDate} ${formattedTime}`;
  }

  getCurrentDateAsString(): string {
    const date = new Date();

    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  static toArray(resp: any): any[] {
    if (resp === undefined) return [];

    const result: any[] = Object.entries(resp).map(([key, value]: [string, any]) => ({
      ...value, // Spread the original object first
      id: key   // Override or add the `id` field
    }));

    return result;
  }

}
